import { useRecordContext } from 'react-admin'

const StateField = (props) => {
  const record = useRecordContext(props)

  if (!record) {
    return null
  }

  let msg = ''
  if (record.processed_state === 2) {
    msg = 'Error'
  } else if (record.processed_state === 1) {
    msg = 'Success'
  } else {
    msg = 'Processing'
  }

  return record ? <span>{msg}</span> : null
}

export default StateField
